
export default [
  {
    path: '/alert-message',
    name: 'Messages',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Messages',
      crud: {
        pageTitle: 'Mensagem de alerta',
        btnText: 'Adicionar mensagem',
        newRouteName: 'MessageNew',
        pageContent: () => import('App/generate-messages/MessageCrudList.vue'),
      },
    },
  },
  {
    path: '/alert-message/new',
    name: 'MessageNew',
    component: () => import('App/generate-messages/MessageForm.vue'),
    meta: {
      itemActive: 'Messages',
    },
  },
  {
    path: '/alert-message/:id',
    name: 'MessageEdit',
    component: () => import('App/generate-messages/MessageForm.vue'),
    meta: {
      itemActive: 'Messages',
    },
  },
];
